import React, { useCallback } from "react";

import Radio, { RadioProps as AntdRadioProps, RadioChangeEvent } from "antd/es/radio";

export interface RadioButtonProps extends Omit<AntdRadioProps, "onChange"> {
  onChange?: (checked: boolean, event: RadioChangeEvent) => void;
}

const RadioButton = ({ onChange, ...props }: RadioButtonProps) => {
  const handleChange = useCallback<NonNullable<AntdRadioProps["onChange"]>>(
    (e) => onChange?.(e.target.checked, e),
    [onChange]
  );

  return <Radio {...props} onChange={handleChange} />;
};

export default RadioButton;
